module.exports = __webpack_public_path__ + "header_one.1faaad354c7843acb688.jpg";


//////////////////
// WEBPACK FOOTER
// D:/taile-operate/BLACK-WIDOW/ng-src/assets/img/landing/header_one.jpg
// module id = ../../../../../ng-src/assets/img/landing/header_one.jpg
// module chunks = styles